// Vue mixin för generisk knapp (button)

import { euiLifecycleStatusesMixin } from 'v-mixins/euiLifecycleStatusesMixin';

// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
let uniktIdCounter = 0;


//------------------------------------------------------------------------------------------------------------------------------

const mixin = {

	mixins: [ euiLifecycleStatusesMixin ],

	props: {
		vpAccessKey: {
			type: String,
			default: null
		},
		vpTooltip: {
			type: String,			// Får innehålla HTML.
			default: null
		},
		vpPaslagen: {
			type: Boolean,
			default: false
		},
		vpInaktiverad: {
			type: Boolean,
			default: false
		},
		vpOsynlig: {
			type: Boolean,
			default: false
		},
	},

	data() {
		return {
			uniktId: 'eui-gen-knapp-unikt-' + (++uniktIdCounter),
		};
	},

	computed: {
		skaVaraOsynlig() {
			return (this.vpOsynlig || !this.lifecycleStatuses.mixinMountedHasOccured);
		},
		skaVaraInaktiverad() {
			return (this.vpInaktiverad || !this.lifecycleStatuses.mixinMountedHasOccured);
		},
	},

	methods: {
		onButton(event)
		{
			//console.log('mixin.onButton emits tryckt: '+ !this.vpPaslagen);
			this.$emit('tryckt');
		},
	},

	mounted() {
		// Note that mounted does not guarantee that all child components have also been mounted.
		//-----------------------------------------------------------------------------------------------------------------------
		// Mixin hooks will be called *before* the component’s/app’s own hooks. Ordning:
		//
		// 1. Mixins mounted hook.
		// 2. Appens/komponentens mounted hook.
		//
		// 3. Mixins mounted hook + nextTick (DOM not updated yet).
		// 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet).
		//
		// 5. Mixins mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
		// 6. Appens/komponentens mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
		//
		// Det är *först efter steg 4* ovan som allt är färdigrenderat, med avseende på Vue-grejs som exempelvis all reaktivitet som förekommer i appen (ex visa/dölj element)!
		//
		// Alltså, saker som ska göras i denna mixins mounted och som ska ske *efter* steg 2 ovan:
		// a) kan göras som steg 3 ovan, *om* det *inte* är beroende av att allt reaktivt är garanterat färdigrenderat eller
		// b) måste göras som steg 5 ovan, *om* det är beroende av att allt reaktivt är garanterat färdigrenderat.
		//-----------------------------------------------------------------------------------------------------------------------

		//## 1. Mixins mounted hook:  #################################		
		//console.log('1. Mixins mounted hook');

		this.$nextTick(function () {
			// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
			// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:

			//## 3. Mixins mounted hook + nextTick (DOM not updated yet):  #################################		
			//console.log('3. Mixins mounted hook + nextTick (DOM not updated yet)');

			// Todo: Delar av denna hantering borde DRYas och delas mellan olika generiska kryssrute-komponenter och inputs (euiSearchText.vue, euiAutocomplete...). I samband med det bör även access-keys "registreras" i central array med dubblettkontroll:
			if (this.vpAccessKey !== null && this.vpAccessKey !== '')
			{
				document.addEventListener('keydown', (e) => {

					if (!this.vpInaktiverad
						&& !this.$el.hasAttribute('disabled')
					)
					{
						// Obs! Access key ska inte funka då knappen är inaktiverad med propen vpInaktiverad.
						// Och till skillnad från kryssrutor så fungerar den inte heller om knappen är disabled (HTML-attribut), ex.vis medelst "eui-maintain-disabled" e.d.

						if (e.defaultPrevented) {
							return; // Do nothing if the event was already processed
						}

						if ((e.target.tagName === 'BODY' || e.target.tagName === 'DIV')
							&& !e.repeat
						)
						{
							//console.log(e);
							//console.log(`Tangent: key="${e.key}", keycode=${e.keyCode}, key.charCodeAt(0)=${e.key.charCodeAt(0)}  ---  vpAccessKey=${this.vpAccessKey}, vpAccessKey.toLowerCase()).charCodeAt(0)=${(this.vpAccessKey.toLowerCase()).charCodeAt(0)}`);

							if (e.altKey		// YES! Alt + ..
								&& !e.ctrlKey	// NO! Ctrl + ..
								&& e.key.length === 1		// För att utesluta "ArrowDown" o.d.
								&& e.key.charCodeAt(0) === (this.vpAccessKey.toLowerCase()).charCodeAt(0)	// "key" omvandlad till "extended ascii"-koder
							) {
								// AccessKeyen tryckt:
								//console.log('HIT!!!');
								this.onButton(e);
							}
						}
					}
				});
			}


			//---------------------------------------------------------------------------------------------------------------

			//Vue.nextTick(function () {

			//		//## 5. Mixins mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated):  #################################		
			//		//console.log('5. Mixins mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated)');

			//	}
			//	, this	// Vue.nextTick 'this' context.
			//);

		});
	}

};

export { mixin as euiGeneriskKnappMixin };

